import { DataBean } from "../DataBean";

export class IncapacityStates extends DataBean {



    public async approveEmployeeIncapacity(idIncapacity:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "employees.EmployeeIncapacity_approveEmployeeIncapacity_Number_Number", [idIncapacity,idEmployee]);
    }
 public async fileEmployeeIncapacity(idIncapacity:any,filedNumber,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "employees.EmployeeIncapacity_fileEmployeeIncapacity_Number_Number_Number", [idIncapacity,filedNumber,idEmployee]);
    }
     public async rejectEmployeeIncapacity(idIncapacity:any,observations:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "employees.EmployeeIncapacity_rejectEmployeeIncapacity_Number_String_Number", [idIncapacity,observations,idEmployee]);
    }


}